import { PyeongSize as PyeongSizeEnum } from '@/entities/map'
import { useMultiScrollState } from '@/shared/lib'

import { Filter, useFilter } from '../../model/filter'
import { Item, List, Title } from '../common/layout'

const PYEONG_SIZES = [
  {
    title: '5평 이하',
    value: PyeongSizeEnum.UNDER_FIVE,
  },
  {
    title: '5평 ~ 10평',
    value: PyeongSizeEnum.FROM_FIVE_TO_TEN,
  },
  {
    title: '10평대',
    value: PyeongSizeEnum.RANGE_TEN,
  },
  {
    title: '20평대',
    value: PyeongSizeEnum.RANGE_TWENTY,
  },
  {
    title: '30평대',
    value: PyeongSizeEnum.RANGE_THIRTY,
  },
  {
    title: '40평 이상',
    value: PyeongSizeEnum.OVER_FORTY,
  },
]

type Props = {
  className?: string
}

export const PyeongSizes = ({ className }: Props) => {
  const { registerScrollElement } = useMultiScrollState<HTMLDivElement>()

  const {
    type,
    filter: { pyeongSizes },
    updateFilter,
  } = useFilter()

  const handlePyeongSizeChange = (value: PyeongSizeEnum) => () => {
    updateFilter({ pyeongSizes: value })
  }

  return (
    <div
      className={className}
      ref={element => {
        if (element) {
          registerScrollElement(Filter.PyeongSizes, element)
        }
      }}
    >
      <Title>평수</Title>
      <List>
        {PYEONG_SIZES.map(({ title, value }) => (
          <Item
            key={title}
            type={type}
            selected={pyeongSizes.includes(value)}
            onClick={handlePyeongSizeChange(value)}
          >
            {title}
          </Item>
        ))}
      </List>
    </div>
  )
}
